import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=91618b86"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.5.0_webpack@5.105.4_postcss@8._9ca5930b91b9e9e517a72aaa81c77ab9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports